var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPageLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1632,
    viewBox: "0 0 1440 1632",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_938_435)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1632,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1809,
    transform: "translate(0 -147)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 50,
    width: 608,
    height: 59,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 397,
    width: 380,
    height: 520,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 983,
    width: 380,
    height: 520,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 531,
    y: 397,
    width: 380,
    height: 520,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 531,
    y: 983,
    width: 380,
    height: 520,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 959,
    y: 397,
    width: 380,
    height: 520,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 959,
    y: 983,
    width: 380,
    height: 520,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 205,
    width: 299,
    height: 50,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449,
    y: 205,
    width: 299,
    height: 50,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241,
    y: 825,
    width: 200,
    height: 50,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241,
    y: 1411,
    width: 200,
    height: 50,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 669,
    y: 825,
    width: 200,
    height: 50,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 669,
    y: 1411,
    width: 200,
    height: 50,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1097,
    y: 825,
    width: 200,
    height: 50,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1097,
    y: 1411,
    width: 200,
    height: 50,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141,
    y: 689,
    width: 200,
    height: 18,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141,
    y: 1275,
    width: 200,
    height: 18,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 569,
    y: 689,
    width: 200,
    height: 18,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 569,
    y: 1275,
    width: 200,
    height: 18,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 997,
    y: 689,
    width: 200,
    height: 18,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 997,
    y: 1275,
    width: 200,
    height: 18,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141,
    y: 715,
    width: 200,
    height: 12,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141,
    y: 1301,
    width: 200,
    height: 12,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 569,
    y: 715,
    width: 200,
    height: 12,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 569,
    y: 1301,
    width: 200,
    height: 12,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 997,
    y: 715,
    width: 200,
    height: 12,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 997,
    y: 1301,
    width: 200,
    height: 12,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141,
    y: 760,
    width: 200,
    height: 12,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141,
    y: 1346,
    width: 200,
    height: 12,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 569,
    y: 760,
    width: 200,
    height: 12,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 569,
    y: 1346,
    width: 200,
    height: 12,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 997,
    y: 760,
    width: 200,
    height: 12,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 997,
    y: 1346,
    width: 200,
    height: 12,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 767,
    y: 205,
    width: 55,
    height: 50,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 121,
    width: 477,
    height: 18,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 1557,
    width: 1236,
    height: 22,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 347,
    width: 177,
    height: 18,
    fill: "#F1F1F1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_938_435"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1632,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageLoading);
export default __webpack_public_path__ + "static/media/page_loading.eb004c872cb6ab5173dc238a82dac23b.svg";
export { ForwardRef as ReactComponent };